import { useRef } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CachedIcon from "@mui/icons-material/Cached";

const UploadDocument = ({ name, label, handleDocUpload, fileData, docLoader, isMandatory }) => {
  const docRef = useRef(null);
  return (
      <div className="flex mb-4 relative">
        <p className="text-sm font-medium text-gray-700 mr-5 my-auto">
          {label}
          {isMandatory && <span className="text-red-500 text-xl">*</span>}
        </p>
        <div className="w-60">
          <input
            type="file"
            ref={docRef}
            accept=".pdf,.jpg,.jpeg,.png"
            name={name}
            onChange={(e) => handleDocUpload(e)}
            className="hidden"
          />
          {fileData?.fileName ? (
            <div className="flex items-center justify-between">
              <span>
                {fileData?.fileName.length > 25
                  ? fileData.fileName.slice(0, 22) + "..."
                  : fileData?.fileName}
              </span>
              <button onClick={() => docRef.current.click()}>
                <CachedIcon style={{ color: "#1976D2" }} />
              </button>
            </div>
          ) : (
            <button onClick={() => docRef.current.click()}>
              <UploadFileIcon style={{ color: "#1976D2" }} /> Upload File
            </button>
          )}
        </div>
        {docLoader && (
          <div className="loader border-4 border-t-4 border-gray-200 border-t-blue-600 rounded-full w-6 h-6 animate-spin mx-auto absolute -right-8 top-1"></div>
        )}
      </div>
  );
};
export default UploadDocument;